import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as constants from '../_model/string_literal';
import { UserData, postUserData } from '../_model/user_data';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  userList: UserData[] = [];
  _userDataChanged = new BehaviorSubject<boolean>(false);
  userDataChanged: boolean = false;
  associateUserList: any[] = [];
  //userApplicationList: userApplication[] = [];
  selectedUserID = '';
  editUserData!: postUserData;
  editUserFlag = false;
  skipListFlag = false;
  zoomFlag = false; 
  private _userList$ = new BehaviorSubject<UserData[]>([]);
  userList$ = this._userList$.asObservable();

  setUserList(data: any) {
    this._userList$.next(data);
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient
  ) { }

  //userList: any[] = [];
//defulat admin list
  getUserList() {
    return this.http.get<UserData[]>(constants.IAPI_ENDPOINT + '/user',this.httpOptionsAuth);
  }

  getUserById(id: any) {
    return this.http.get(constants.IAPI_ENDPOINT + `/user/${id}`,this.httpOptionsAuth);
  }

  getUserCount() {
    return this.http.get<{count:number}>(constants.IAPI_ENDPOINT + '/user/count',this.httpOptionsAuth);
  }

  getUserChanged() {
    return this._userDataChanged.asObservable();
  }
  userListUpdate() {
    this.getUserList().subscribe({
      next: (value) => {
        this.userList = value;
        this.setUserList(value);
        console.log(this.userList)
      },
    })
  }

  getAuth(){
    return this.http.get<{userId: string}>(constants.IAPI_ENDPOINT + '/auth/check',this.httpOptionsAuth);
  }

  submitExistingUser(userData: any){
    return this.http.put(constants.IAPI_ENDPOINT + '/user/' + `${this.selectedUserID}`, JSON.stringify(userData), this.httpOptionsAuth);
  }

  submitNewUser(inviteUserData: any){
    return this.http.post(constants.IAPI_ENDPOINT + '/user/jinvite' , JSON.stringify(inviteUserData), this.httpOptionsAuth);
  }

  deleteUserData(userId : any){
    return this.http.post(constants.IAPI_ENDPOINT + '/user/juserdel', JSON.stringify({"userId": userId}), this.httpOptionsAuth); 
  }

  resetEditUser(){
    this.editUserData = {
      name: '',
      first_name: '',
      last_name: '',
      pincode: '',
      position: '',
      address: '',
      telephone: '',
      fax: '',
      email: '',
      thumbnailExtension: '',
      oid: '',
      company_id: '',
      role_id: 1,
      tenant_id: '',
      vessel_id: '',
    };
    this.editUserFlag = false;
  }

  resetSelectedUserID() {
    this.selectedUserID = '';
  }

}
